module.exports = __webpack_public_path__ + "static/img/ba-icon.5aed7fb8.gif";